import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { ADDRESS, CALENDAR_PERIOD, CITY, CONTINENT, COUNTRY, COUNTY, CURRENCY, DATASET_LINK, DATE, DATE_TIME, NUMBER, PERCENT, POSTAL_CODE, ROLLUP, STATE_PROVINCE, TEXT, TIME, YES_NO, FILE } = DataType
import dataTypes from 'scoreboard/datasets/edit/data-types'

const DATA_SUPER_TYPE = {
	TEXT: TEXT,
	YES_NO: YES_NO,
	NUMERIC: 'numeric',
	DATE_TIME: DATE_TIME,
	GEOGRAPHIC: 'geographic',
	ROLLUP: ROLLUP,
	DATASET_LINK: DATASET_LINK,
	FILE: FILE
}

// #37796 Front end only; Used to filter data types in the data type dropdown.
const dataSupertypes = [ {
	id: DATA_SUPER_TYPE.TEXT,
	icon: TEXT,
	group: 'headerless',
	dataTypes: [TEXT],
	label: 'dashboards.dashboard.text'
}, {
	id: DATA_SUPER_TYPE.YES_NO,
	icon: 'yes-no-data-type',
	group: 'headerless',
	dataTypes: [YES_NO],
	label: 'admin.scorecards.metric.scoringType.yesNo'
}, {
	id: DATA_SUPER_TYPE.NUMERIC,
	icon: 'number',
	group: 'headerless',
	dataTypes: [NUMBER, PERCENT, CURRENCY],
	label: 'datasets.datatype.groups.numeric'
}, {
	id: DATA_SUPER_TYPE.DATE_TIME,
	icon: DATE_TIME,
	group: 'headerless',
	dataTypes: [DATE, TIME, DATE_TIME, CALENDAR_PERIOD],
	label: 'datasets.datatype.groups.dateTime'
}, {
	id: DATA_SUPER_TYPE.GEOGRAPHIC,
	icon: 'geography',
	group: 'headerless',
	dataTypes: [
		CONTINENT,
		COUNTRY,
		STATE_PROVINCE,
		COUNTY,
		POSTAL_CODE,
		CITY,
		ADDRESS

		// #48265 initially unsupported geographic data types
		//'voting-district',
		//'latitude',
		//'longitude',
		//'latitude-longitude'
	],
	label: 'datasets.datatype.groups.geographic'
}, {
/*	#60055 hide file data type in 5.7.0 since #59261 won't be implemented until 5.7.1
	id: DATA_SUPER_TYPE.FILE,
	icon: 'document-blank',
	group: 'headerless',
	dataTypes: [FILE],
	label: 'common.file'
}, {*/
	id: DATA_SUPER_TYPE.ROLLUP,
	icon: 'rollup-tree',
	group: 'advanced',
	dataTypes: [ROLLUP],
	label: 'datasets.dataType.rollup'
}, {
	id: DATA_SUPER_TYPE.DATASET_LINK,
	icon: DATASET_LINK,
	group: 'advanced',
	dataTypes: [DATASET_LINK],
	label: 'datasets.datatype.link'
} ]

const dataSuperTypesById = _.keyBy(dataSupertypes, type => type.id)

const dataSuperTypesByDataType = {}
dataTypes.forEach(dataType => {
	dataSuperTypesByDataType[dataType.id] =
		_.find(dataSupertypes, superType => _.includes(superType.dataTypes, dataType.id))
})

function getDataSuperTypeForDataType(dataType) {
	return dataSuperTypesByDataType[dataType]?.id
}

export default dataSupertypes
export { dataSuperTypesById }
export { dataSuperTypesByDataType }
export { DATA_SUPER_TYPE }
export { getDataSuperTypeForDataType }

dataSupertypes.__filename__ = 'datasets/edit/fields/data-super-types.js'
